import { render, staticRenderFns } from "./collectInfoDialog.vue?vue&type=template&id=6c58cf7f&scoped=true"
import script from "./collectInfoDialog.vue?vue&type=script&lang=js"
export * from "./collectInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./collectInfoDialog.vue?vue&type=style&index=0&id=6c58cf7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58cf7f",
  null
  
)

export default component.exports